const anchorPageGoTop = document.querySelector('.anchor');
const offsetDisplayAnchorLimit = 700;

const createSmoothAnchorsInPage = () => {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      e.preventDefault();

      document.querySelector(anchor.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
      });
    });
  });
};

const displayTopAnchorOnUserScroll = () => {
  document.addEventListener('scroll', () => {
    const goTopIsEnabled = anchorPageGoTop.classList.contains('enable');
    if (window.pageYOffset >= offsetDisplayAnchorLimit && !goTopIsEnabled) {
      anchorPageGoTop.classList.add('enable');
    } else if (window.pageYOffset < offsetDisplayAnchorLimit && goTopIsEnabled) {
      anchorPageGoTop.classList.remove('enable');
    }
  });
  onAnchorClicked();
};

const onAnchorClicked = () => {
  anchorPageGoTop.addEventListener('click', () => {
    document.querySelector('body').scrollIntoView({
      behavior: 'smooth'
    })
  });
};

anchorPageGoTop && displayTopAnchorOnUserScroll();
createSmoothAnchorsInPage();
